export const getFirstValue = obj => obj && Object.values(obj)[0]
